import { Component, inject, Input } from "@angular/core";
import { AppliedBranchDetails } from "../apply-asset-request/apply-asset-request.component";
import { SharedService } from "src/app/Shared/shared-service.service";
import { ALERT_TYPE } from "src/app/constants";
import { AssetSummaryReportComponent } from "src/app/Report/asset-summary-report/asset-summary-report.component";
import { Company } from "src/model/company.model";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AssetRequestSummaryComponent } from "../asset-request-summary/asset-request-summary.component";

@Component({
  selector: "app-asset-contra-details",
  standalone: false,
  templateUrl: "./asset-contra-details.component.html",
  styleUrl: "./asset-contra-details.component.scss",
})
export class AssetContraDetailsComponent {
  @Input() selectedApplyOpt: string;
  @Input() protected companyId: number;
  @Input() protected companyCode: string;

  protected isReturn = false;
  protected disableSubmit = false;
  protected remark = "";

  protected applyBranches: AppliedBranchDetails[] = new Array();
  protected returnBranches: AppliedBranchDetails[] = new Array();
  protected sharedService = inject(SharedService);
  protected activeModal = inject(NgbActiveModal);

  checkError() {
    let error: string[] = [];
    let applyTotal = this.sharedService.getListTotalWithKey(
      this.applyBranches,
      "amount",
    );
    let returnTotal = this.sharedService.getListTotalWithKey(
      this.returnBranches,
      "amount",
    );

    if (
      this.sharedService.roundTo2Dec(applyTotal) !=
      this.sharedService.roundTo2Dec(returnTotal)
    )
      error.push("- Return Amount and apply amount is not tally!");

    const branchExistedBothList = this.applyBranches.some((x) =>
      this.returnBranches.some(
        (y) => y.appliedBranch.ID === x.appliedBranch.ID,
      ),
    );

    if (branchExistedBothList)
      error.push(
        "- There is at least a branch contains in both return and apply list!",
      );

    if (this.remark == "") error.push("- Remark is empty!");
    return error;
  }

  submit() {
    this.disableSubmit = true;
    let error = this.checkError();
    if (error.length > 0) {
      this.sharedService.openAlert(
        "Please fix the following issue:\n" + error.join("\n"),
        ALERT_TYPE.DANGER,
      );
      this.disableSubmit = false;
    } else {
      const modalRef = this.sharedService.openModal(
        AssetRequestSummaryComponent,
        "largeModal",
      );
      modalRef.componentInstance.type = this.selectedApplyOpt;
      modalRef.componentInstance.reason = this.selectedApplyOpt;
      modalRef.componentInstance.selectedApplyOpt = this.selectedApplyOpt;

      modalRef.componentInstance.loggedInCompany = new Company(
        this.companyId,
        undefined,
        undefined,
        this.companyCode,
      );

      modalRef.componentInstance.contraApplyBranches = this.applyBranches;
      modalRef.componentInstance.contraReturnBranches = this.returnBranches;
      modalRef.componentInstance.reason = this.remark;
      this.activeModal.close();
    }
  }
}
